module.exports = __webpack_public_path__ + "img/undraw_barbecue.f7faebe9.svg";